import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { autobind } from 'core-decorators';
import trim from 'lodash/trim';
import CSSModules from 'react-css-modules';

import sanitizeHtml from '../../../utils/sanitizeHtml';
import Button from '../../Button';
import TextInput from '../../TextInput';
import { ACTIONS, POST_COMMENTS_ADD } from '../../../constants/strings';
import { COLORS } from '../../../constants/styles';
import { IDS } from '../../../constants/ids';
import styles from './index.styl';

const COMMENT_LIMIT_SIZE = 500;

@CSSModules(styles)
export default class AddComment extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
  };

  state = {
    content: '',
  };

  @autobind
  handleSubmit() {
    const { content } = this.state;
    const { onSubmit } = this.props;

    // eslint-disable-next-line no-unused-expressions
    onSubmit && onSubmit(sanitizeHtml(content, true, []));
    this.setState({ content: '' });
  }

  render() {
    const { content: value } = this.state;
    const disabled = typeof value === 'string' && !trim(value).length;

    const label = (
      <span
        style={{
          opacity: '.8',
          color: COLORS.bluePrimary,
        }}
      >
        <FormattedMessage {...POST_COMMENTS_ADD} />
      </span>
    );

    return (
      <div styleName="root">
        <div>
          <TextInput
            autoresize
            textarea
            rows="4"
            id={IDS.POST.POST_TEXT_AREA}
            className="fw5"
            color="primary"
            label={label}
            limit={COMMENT_LIMIT_SIZE}
            style={{
              lineHeight: '21px',
              height: 'auto',
              maxHeight: 21 * 10,
              backgroundColor: 'white',
              border: `1px solid ${COLORS.sanMarino}`,
            }}
            value={value}
            onChange={content => this.setState({ content })}
            rounded
            useNumberHeight
          />
        </div>
        <Button
          id={IDS.POST.POST_COMMENT}
          className="mt3"
          color="primary"
          raised
          type="button"
          onClick={this.handleSubmit}
          disabled={disabled}
        >
          <FormattedMessage {...ACTIONS.post.createComment} />
        </Button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Post/AddComment/index.jsx